import {clsx} from 'clsx'
import {XIcon} from '@primer/octicons-react'

import {dismissAnalytics} from '../../utils/analytics'
import styles from './CloseButton.module.css'

/** `data-action` wires the click to the existing Catalyst `global-banner` controller for dismissal. */
export function CloseButton({
  uid,
  wrapperClassName,
  buttonClassName,
}: {
  uid: string
  wrapperClassName: string
  buttonClassName?: string
}) {
  return (
    <div className={wrapperClassName}>
      <button
        type="button"
        aria-label="Close"
        className={clsx(styles.button, buttonClassName)}
        data-action="click:global-banner#close"
        data-analytics-event={dismissAnalytics(uid)}
      >
        <XIcon className={styles.icon} />
      </button>
    </div>
  )
}
